module.exports = __webpack_public_path__ + "assets/Lato-Black.7c5b01bafa24bbb18ea8fcabc795b38230fe3c80987cf1bdbb561369ad4573a6.woff";